import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdLabelOptions } from '@onefootprint/fetch-dashboard';
import { IcoTrash16 } from '@onefootprint/icons';
import type { LabelKind } from '@onefootprint/request-types/dashboard';
import { Dropdown } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useEntityId from '@/entity/hooks/use-entity-id';
import useLabelText from '@/entity/hooks/use-label-text';
import useEditLabel from '@/hooks/use-edit-label';
import usePermissions from '@/hooks/use-permissions';
import Trigger from './trigger';
const LABEL_KIND_VALUES: LabelKind[] = ['active', 'offboard_fraud', 'offboard_other'] as const;
type FraudLabelProps = {
  hideWhenEmpty?: boolean;
};
const FraudLabel = t0 => {
  const $ = _c(35);
  const {
    hideWhenEmpty
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "headerDefault.fraudLabel"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const labelT = useLabelText();
  const entityId = useEntityId();
  let t2;
  if ($[1] !== entityId) {
    t2 = getEntitiesByFpIdLabelOptions({
      path: {
        fpId: entityId
      }
    });
    $[1] = entityId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !!entityId;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      ...t2,
      enabled: t3,
      select: _temp
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data: label_0,
    isPending,
    error
  } = useQuery(t4);
  const {
    hasPermission
  } = usePermissions();
  let t5;
  if ($[6] !== hasPermission) {
    t5 = hasPermission("label_and_tag");
    $[6] = hasPermission;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const canEditLabel = t5;
  const [isOpen, setIsOpen] = useState(false);
  const editLabelMutation = useEditLabel();
  let t6;
  if ($[8] !== canEditLabel) {
    t6 = () => {
      if (!canEditLabel) {
        return;
      }
      setIsOpen(_temp2);
    };
    $[8] = canEditLabel;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const toggleDropdown = t6;
  let t7;
  if ($[10] !== editLabelMutation || $[11] !== entityId) {
    t7 = kind => {
      editLabelMutation.mutate({
        body: {
          kind
        },
        path: {
          fpId: entityId
        }
      }, {
        onSuccess: () => {
          setIsOpen(false);
        }
      });
    };
    $[10] = editLabelMutation;
    $[11] = entityId;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleEditLabel = t7;
  if (error || isPending || hideWhenEmpty && !label_0) {
    return null;
  }
  const t8 = !canEditLabel;
  let t9;
  if ($[13] !== label_0 || $[14] !== t8) {
    t9 = <Trigger value={label_0} disabled={t8} />;
    $[13] = label_0;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = label_0 ? "end" : "start";
  let t11;
  if ($[16] !== handleEditLabel || $[17] !== labelT || $[18] !== label_0) {
    t11 = LABEL_KIND_VALUES.map(labelOption => <Dropdown.Item key={labelOption} onClick={() => handleEditLabel(labelOption)} checked={labelOption === label_0}>{labelT(labelOption)}</Dropdown.Item>);
    $[16] = handleEditLabel;
    $[17] = labelT;
    $[18] = label_0;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <Dropdown.Group>{t11}</Dropdown.Group>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== handleEditLabel || $[23] !== label_0 || $[24] !== t) {
    t13 = label_0 && <><Dropdown.Divider /><Dropdown.Group><Dropdown.Item onClick={() => handleEditLabel(undefined)} destructive={true} iconLeft={IcoTrash16}>{t(_temp3)}</Dropdown.Item></Dropdown.Group></>;
    $[22] = handleEditLabel;
    $[23] = label_0;
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t13) {
    t14 = <Dropdown.Content align={t10} sideOffset={4}>{t12}{t13}</Dropdown.Content>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isOpen || $[31] !== t14 || $[32] !== t9 || $[33] !== toggleDropdown) {
    t15 = <Dropdown.Root open={isOpen} onOpenChange={toggleDropdown}>{t9}{t14}</Dropdown.Root>;
    $[30] = isOpen;
    $[31] = t14;
    $[32] = t9;
    $[33] = toggleDropdown;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
export { LABEL_KIND_VALUES };
export default FraudLabel;
function _temp(label) {
  return label.kind ? label.kind : undefined;
}
function _temp2(prev) {
  return !prev;
}
function _temp3($) {
  return $.labels.remove;
}